// app/components/Plugins/Automations/core/NodeFactory.ts

import { AutomationNode } from '../types';
import { NodeProtocol } from './protocols';
import { BaseNode } from './BaseNode';

// Import node implementations
import { StartNodeImpl } from '../nodes/implementations/StartNodeImpl';
import { IndicatorNodeImpl } from '../nodes/implementations/IndicatorNodeImpl';
import { BuySellNodeImpl } from '../nodes/implementations/BuySellNodeImpl';
import { StatusNodeImpl } from '../nodes/implementations/StatusNodeImpl';
import { StopNodeImpl } from '../nodes/implementations/StopNodeImpl';


/**
 * Factory class for creating node implementations
 */
export class NodeFactory {
  /**
   * Create a node implementation based on the node type
   * @param node The automation node to create an implementation for
   */
  static createNode(node: AutomationNode): NodeProtocol {
    switch (node.type) {
      case 'startNode':
        return new StartNodeImpl(node);
      case 'indicatorNode':
        return new IndicatorNodeImpl(node);
      case 'buySellNode':
        return new BuySellNodeImpl(node);
      case 'statusNode':
        return new StatusNodeImpl(node);
      case 'stopNode':
        return new StopNodeImpl(node);
      default:
        throw new Error(`Unknown node type: ${node.type}`);
    }
  }
}